module.exports = __webpack_public_path__ + "static/PlushCare-daaf9f753f81cbabecc49e15d0f12d03.png";